import React from 'react';

import Layout from '../components/Layout';

class KeyRings extends React.Component {

    render(){
        return(
            <Layout>
                <h1>Key Rings</h1>
            </Layout>
        );
    }
}

export default KeyRings;